import { render } from "./WifiItem.vue?vue&type=template&id=0c6bb880"
import script from "./WifiItem.vue?vue&type=script&lang=js"
export * from "./WifiItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__